/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
import { WebPlugin } from '@capacitor/core';
import { WEBFORM } from './webform';
// noinspection DuplicatedCode
export class CFBridgeWeb extends WebPlugin {
    constructor() {
        super({
            name: 'CFBridgePlugin',
            platforms: ['web'],
        });
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    async getUPIApps() {
        return Promise.resolve({ apps: [] });
    }
    async startPaymentUPI(
    // eslint-disable-next-line @typescript-eslint/ban-types
    params) {
        console.log(params);
        return Promise.resolve({ status: 'ERROR', message: 'Not implemented' });
    }
    async startPaymentWEB(
    // eslint-disable-next-line @typescript-eslint/ban-types
    params) {
        if (params instanceof Map) {
            try {
                return WEBFORM.startPaymentWEB(CFBridgeWeb.strMapToObj(params));
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        else {
            try {
                return WEBFORM.startPaymentWEB(params);
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
    }
    static strMapToObj(strMap) {
        const obj = Object.create(null);
        for (const [k, v] of strMap) {
            // We don’t escape the key '__proto__'
            // which can cause problems on older engines
            obj[k] = v;
        }
        return obj;
    }
}
//# sourceMappingURL=web.js.map